"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextareaContainer = exports.StyledTextarea = exports.CounterWrapper = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledTextarea = exports.StyledTextarea = _ykbStyledComponents.default.textarea.withConfig({
  componentId: "ykb-ui__sc-8ffhx1-0"
})(["border:", ";border-radius:", ";height:", ";font-size:", ";font-family:", ";position:relative;padding:", ";width:", ";max-width:100%;max-height:100%;&:hover{border-color:", ";}&:focus{border-color:", ";outline:0;box-shadow:0 0 3px 3px ", ";border-right-width:1px;}&::placeholder{color:", ";opacity:1;}&:-ms-input-placeholder{color:", ";}&::-ms-input-placeholder{color:", ";}&.readonly,&:read-only{resize:none;border:0;box-shadow:none;}&::-ms-clear{display:none;}&:disabled,&.disabled{resize:none;opacity:1;cursor:not-allowed;background-color:", ";border:", ";color:", ";&:hover,&:focus{border-color:", ";box-shadow:'none';}}"], function (props) {
  return props.theme.textarea.border;
}, function (props) {
  return props.theme.textarea.borderRadius;
}, function (props) {
  return props.theme.textarea.height;
}, function (props) {
  return props.theme.textarea.fontSize;
}, function (props) {
  return props.theme.font.family;
}, function (props) {
  return props.theme.textarea.padding;
}, function (props) {
  return props.theme.textarea.width;
}, function (props) {
  return props.theme.input.hover.borderColor;
}, function (props) {
  return props.theme.input.hover.borderColor;
}, function (props) {
  return props.theme.input.focus.boxShadowColor;
}, function (props) {
  return props.theme.input.placeHolderColor;
}, function (props) {
  return props.theme.input.placeHolderColor;
}, function (props) {
  return props.theme.input.placeHolderColor;
}, function (props) {
  return props.theme.input.disabled.backgroundColor;
}, function (props) {
  return props.theme.textarea.disabled.border;
}, function (props) {
  return props.theme.input.disabled.color;
}, function (props) {
  return props.theme.input.disabled.hover.borderColor;
});
var StyledTextareaContainer = exports.StyledTextareaContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-8ffhx1-1"
})(["display:inline-block;width:100%;height:auto;", "{resize:vertical;display:block;}> span{text-align:right;font-weight:500;display:block;font-size:12px;line-height:12px;margin-top:2px;", "}"], StyledTextarea, function (props) {
  return props.$warning && (0, _ykbStyledComponents.css)(["color:", ";"], function (props) {
    return props.theme.color.danger6;
  });
});
var CounterWrapper = exports.CounterWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-8ffhx1-2"
})(["", ""], function (props) {
  return props.$showLineNumber && (0, _ykbStyledComponents.css)(["display:inline-flex;gap:10px;line-height:21px;border-radius:2px;position:relative;position:relative;padding-top:0px;padding-bottom:0px;overflow:hidden;width:100%;.line-numbers{text-align:center;overflow:hidden;position:absolute;left:0px;top:4px;text-align:right;width:100%;padding-right:6px;}.line-numbers span{counter-increment:section;}.line-numbers span::before{content:counter(section) \". \";display:block;font-size:12px;}", "{line-height:21px;margin:4px;padding:0px;padding-left:4px;overflow:auto;white-space:pre;white-space:normal;overflow-wrap:normal;resize:none;"], StyledTextarea);
});